import ApiCaller from "../../Connection/ApiCaller";

const onFetchSigninLogs = async (
  fromDate,
  toDate,
  pageIndex,
  pageSize,
  searchTerm
) => {
  return await ApiCaller.get("/signin-logs", {
    FromDate: fromDate,
    Todate: toDate,
    PageIndex: pageIndex,
    PageSize: pageSize,
    Search: searchTerm,
  });
};

const onFetchSigninLogsSearch = async (fromDate, toDate, searchTerm) => {
  return await ApiCaller.get("/signin-logs", {
    FromDate: fromDate,
    Todate: toDate,
    Search: searchTerm,
  });
};

const onFetchLogStatistic = async (fromDate, toDate, statisticType) => {
  return await ApiCaller.get("/signin-logs/statistic", {
    FromDate: fromDate,
    Todate: toDate,
    StatisticType: statisticType,
  });
};

const onFetchLogStatisticUpdate = async (fromDate, toDate, statisticType) => {
  return await ApiCaller.get("/signin-logs/statistic", {
    FromDate: fromDate,
    Todate: toDate,
    StatisticType: statisticType,
  });
};

export { onFetchSigninLogs, onFetchLogStatistic, onFetchSigninLogsSearch, onFetchLogStatisticUpdate};
